var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "RmaOrder" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          toggle: "",
                          disabled: _vm.insertReadonly.StatusId
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("get.RmaOrder.General"), active: "" }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "WarehouseId",
                            error: _vm.$v.form.WarehouseId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.WarehouseId,
                              url: "VisionNextWarehouse/api/Warehouse/Search",
                              "dynamic-and-condition": {
                                IsVehicle: 0,
                                IsVirtualWarehouse: 0,
                                StatusIds: [1]
                              }
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "WarehouseId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.warehouse,
                              callback: function($$v) {
                                _vm.warehouse = $$v
                              },
                              expression: "warehouse"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerId",
                            error: _vm.$v.form.CustomerId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              source: _vm.customers,
                              label: "Label",
                              disabled:
                                _vm.insertReadonly.CustomerId ||
                                !_vm.customerValid
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "CustomerId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.customer,
                              callback: function($$v) {
                                _vm.customer = $$v
                              },
                              expression: "customer"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RepresentativeId",
                            error: _vm.$v.form.RepresentativeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RepresentativeId,
                              url:
                                "VisionNextEmployee/api/Employee/AutoCompleteSearch",
                              orConditionFields:
                                "Code,Description1,Name,Surname"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "RepresentativeId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "Genexp1",
                            error: _vm.$v.form.Genexp1
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "text",
                              disabled: _vm.insertReadonly.Genexp1
                            },
                            model: {
                              value: _vm.form.Genexp1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "Genexp1", $$v)
                              },
                              expression: "form.Genexp1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RmaOrderDate",
                            error: _vm.$v.form.RmaOrderDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: {
                              disabled: _vm.insertReadonly.RmaOrderDate
                            },
                            model: {
                              value: _vm.form.RmaOrderDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "RmaOrderDate", $$v)
                              },
                              expression: "form.RmaOrderDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RmaTypeId",
                            error: _vm.$v.form.RmaTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RmaTypeId,
                              "lookup-key": "RETURN_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("RmaTypeId", $event)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "PriceDate",
                            error: _vm.$v.form.PriceDate
                          }
                        },
                        [
                          _c("NextDatePicker", {
                            attrs: { disabled: _vm.insertReadonly.PriceDate },
                            model: {
                              value: _vm.form.PriceDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "PriceDate", $$v)
                              },
                              expression: "form.PriceDate"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RmaReasonId",
                            error: _vm.$v.form.RmaReasonId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RmaReasonId,
                              url: "VisionNextRma/api/RmaReason/Search",
                              label: "Description1"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedSearchType(
                                  "RmaReasonId",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "RmaStatusId",
                            error: _vm.$v.form.RmaStatusId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.RmaStatusId,
                              "lookup-key": "RMA_STATUS"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType("RmaStatusId", $event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.RMA.Item"),
                            md: "3",
                            lg: "3",
                            required: true,
                            error: _vm.$v.rmaOrderLine.item
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url: "VisionNextItem/api/Item/AutoCompleteSearch",
                              searchable: "",
                              "dynamic-and-condition": {
                                StatusIds: [1],
                                CardTypeIds: [1, 2, 8]
                              },
                              "or-condition-fields": "Description1,Code",
                              "custom-option": true,
                              label: "Code"
                            },
                            on: { input: _vm.selectedItem },
                            model: {
                              value: _vm.rmaOrderLine.item,
                              callback: function($$v) {
                                _vm.$set(_vm.rmaOrderLine, "item", $$v)
                              },
                              expression: "rmaOrderLine.item"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.RMA.ItemName"),
                            md: "2",
                            lg: "2"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text", disabled: true },
                            model: {
                              value: _vm.rmaOrderLine.Item.Description1,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.rmaOrderLine.Item,
                                  "Description1",
                                  $$v
                                )
                              },
                              expression: "rmaOrderLine.Item.Description1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.RMA.Quantity"),
                            required: true,
                            error: _vm.$v.rmaOrderLine.Quantity,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text" },
                            on: {
                              keypress: function($event) {
                                _vm.onlyForCurrencyDotOrComma($event)
                                _vm.keypress($event)
                              }
                            },
                            model: {
                              value: _vm.rmaOrderLine.Quantity,
                              callback: function($$v) {
                                _vm.$set(_vm.rmaOrderLine, "Quantity", $$v)
                              },
                              expression: "rmaOrderLine.Quantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "ml-auto", attrs: { md: "2", lg: "2" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mt-4",
                                  attrs: { variant: "success", size: "sm" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addItems()
                                    }
                                  }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-plus" }),
                                  _vm._v(_vm._s(_vm.$t("insert.add")))
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "2", lg: "2" } },
                        [
                          _c("NextMultipleSelection", {
                            attrs: {
                              name: "RmaOrderMultipleItem",
                              "dynamic-and-condition": {
                                ToWarehouseIds: _vm.form.WarehouseId
                                  ? [_vm.form.WarehouseId]
                                  : null,
                                FromWarehouseIds: _vm.form.WarehouseId
                                  ? [_vm.form.WarehouseId]
                                  : null
                              },
                              "disabled-button": !_vm.form.WarehouseId,
                              "hidden-values": _vm.hiddenValues,
                              "filter-func": function(row) {
                                return row.Quantity > 0
                              },
                              "order-by-columns": [
                                { column: "SortOrder", orderByType: 0 }
                              ]
                            },
                            model: {
                              value: _vm.rmaOrderLines,
                              callback: function($$v) {
                                _vm.rmaOrderLines = $$v
                              },
                              expression: "rmaOrderLines"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-table-simple",
                            {
                              attrs: { responsive: "", bordered: "", small: "" }
                            },
                            [
                              _c(
                                "b-thead",
                                [
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("insert.RMA.Item")))
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("insert.RMA.ItemName"))
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("insert.RMA.Quantity"))
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("b-th", [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("list.operations")))
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tbody",
                                _vm._l(_vm.rmaOrderLines, function(w, i) {
                                  return _c(
                                    "b-tr",
                                    { key: i },
                                    [
                                      _c("b-td", [
                                        _vm._v(
                                          _vm._s(w.Item ? w.Item.Code : w.Code)
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(
                                          _vm._s(
                                            w.Item
                                              ? w.Item.Description1
                                              : w.Description1
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("b-td", [
                                        _vm._v(
                                          _vm._s(_vm.formatValue(w.Quantity))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-td",
                                        { staticClass: "text-center" },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "btn mr-2 btn-danger btn-sm",
                                              attrs: {
                                                title: _vm.$t("list.delete")
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeItems(w)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "far fa-trash-alt"
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7f73768", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7f73768","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RmaOrder/insert.vue
// module id = null
// module chunks = 